import React from "react";

const PauseIcon = ({
  width = 32,
  height = 32,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
        fill="#1A1A1A"
      />
      <path
        d="M10.6665 11.8517C10.6665 11.1971 11.1971 10.6665 11.8517 10.6665H20.148C20.8025 10.6665 21.3332 11.1971 21.3332 11.8517V20.148C21.3332 20.8025 20.8025 21.3332 20.148 21.3332H11.8517C11.1971 21.3332 10.6665 20.8025 10.6665 20.148V11.8517Z"
        fill="white"
      />
    </svg>
  );
};

export default PauseIcon;
